/*
 * @Description:
 * @Author: hejiajun
 * @Date: 2026-02-02 10:13:17
 * @LastEditors: hejiajun
 * @LastEditTime: 2026-02-05 14:50:05
 */

export const DEFAULT_ROUTE = '/blog';

// 定义各子应用的路由前缀（方便统一管理）
const APP_ROUTES = {
  BLOG: [DEFAULT_ROUTE], // 博客应用的路由前缀列表
};

const appConfig = [
  // 博客子应用 - 主入口
  {
    name: "index",
    module: "blog",
    activeWhen: (location) => {
      return APP_ROUTES.BLOG.some((prefix) =>
        location.pathname.startsWith(prefix),
      );
    },
    // 自定义 props：处理从根路径访问时的重定向
    customProps: {
      redirectTo: DEFAULT_ROUTE, // 访问 / 时重定向到 /blog
    },
  },
];

export default appConfig;
